module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CheckoutSteps":{"cart":"Nákupní košík","finished":"Objednávka dokončena","information":"Vaše údaje","shippingAndPayment":"Doprava a platba"}}}')
  delete Component.options._Ctor
}
